"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOgLocale = exports.getLocale = exports.setLocale = void 0;
const window_or_global_1 = __importDefault(require("window-or-global"));
const defaultLocale = 'en-US';
const setLocale = (newLocale) => {
    if (!newLocale)
        return;
    window_or_global_1.default.__epic_common_locale = newLocale;
};
exports.setLocale = setLocale;
const getLocale = () => {
    return window_or_global_1.default.__epic_common_locale || defaultLocale;
};
exports.getLocale = getLocale;
const getOgLocale = () => {
    let locale = (0, exports.getLocale)();
    if (locale.indexOf('-') !== -1) {
        locale = locale.replace('-', '_');
    }
    return locale;
};
exports.getOgLocale = getOgLocale;
//# sourceMappingURL=locale.js.map